var map = {
	"./advoco/favicon.ico": 1386,
	"./nobrand/favicon.ico": 1387,
	"./tellit/favicon.ico": 1388
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1385;


//////////////////
// WEBPACK FOOTER
// ./src/images/branding ^\.\/.*\/favicon\.ico$
// module id = 1385
// module chunks = 0